export default __webpack_public_path__ + "static/media/GridOn.6c00bafc.webp";